import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { portalThemeResolver } from './core/resolvers/portal-theme.resolver';

export const routes: Routes = [
  { path: '', redirectTo: 'donation', pathMatch: 'full' },
  {
    path: 'donation',
    data: { portal: 'donation' },
    resolve: { _theme: portalThemeResolver },
    canActivate: [authGuard],
    loadComponent: () => import('./donation-portal/donation-portal.component').then(m => m.DonationPortalComponent),
    loadChildren: () => import('./donation-portal/donation-portal.routes').then(m => m.donationRoutes)
  },
  {
    path: 'admin',
    redirectTo: 'donation',
    pathMatch: 'prefix'
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found-page.component').then(m => m.NotFoundPageComponent)
  }
];
